<!--
 * @Author: zhaoliang
 * @Date: 2025-07-28 17:13:13
 * @LastEditTime: 2026-01-27 17:24:09
 * @LastEditors: zhaoliang
 * @Description:
 * @FilePath: /visa-canada/src/views/Membership/component/PrivacySettings/Switcher.vue
 *
-->
<template>
  <div class="switch" @click.stop="onChange">
    <input :class="{ checked: value }" type="checkbox" :checked="value" />
    <div class="slider round">
      <div class="circle"></div>
    </div>
  </div>
</template>
<script>
  export default {
    name: 'PrivacySwitcher',
    emits: ['change'],
    props: {
      value: {
        type: Boolean,
        default: false,
      },
    },
    methods: {
      onChange() {
        this.$emit('change', !this.value);
      },
    },
  };
</script>
<style lang="scss" scoped>
  .switch {
    position: relative;
    display: inline-block;
    /* prettier-ignore */
    width: 40Px;
    /* prettier-ignore */
    height: 24Px;
  }

  .switch input {
    display: none;
  }

  .slider {
    position: absolute;
    cursor: pointer;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: #ccc;
    display: flex;
    align-items: center;
    /* prettier-ignore */
    border-radius: 24Px;
  }

  .slider .circle {
    position: absolute;
    /* prettier-ignore */
    height: 20Px;
    /* prettier-ignore */
    width: 20Px;
    left: 2px;
    right: unset;
    background-color: white;
    border-radius: 50%;
  }

  input.checked + .slider {
    background-color: #163049;
  }

  input.checked + .slider .circle {
    right: 2px;
    left: unset;
  }
</style>
